import { useOrgStore } from '@/stores/org-store';
import { apiRequest } from '@/utils/api-request';
import { Collection } from '@/types/source-types';

interface GetCollectionResponse {
  data?: Collection;
  detail?: string;
}

export const getCollection = async (id: string) => {
  const orgId = useOrgStore.getState().currentOrg?.orgid;

  if (!orgId) {
    throw new Error('Organization ID is required');
  }

  const response = await apiRequest<GetCollectionResponse>({
    url: `/collections/${orgId}/${id}`,
    method: 'GET',
    target: 'platform',
  });

  if (response?.detail) {
    return {
      detail: response.detail || 'Failed to get collection',
    };
  }

  return response?.data;
};
